import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c8479fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "dialog-footer" }

import { ref, watch, computed } from 'vue'
import {
  queryUserUpdate,
  queryUserAdd,
  queryUserOrg,
  queryRoleList,
  queryUserDetail,
  queryRoleTreeList,
} from '@/api'
import type { FormInstance } from 'element-plus'
import { CODE_ENUM } from '@/common/enum'
import { ElMessage } from 'element-plus'
import { passwordReg, phoneReg, accountReg } from '@/common/regexp'
import { isEmpty } from 'lodash'
import { encode } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'user-modal',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryRole()
      if (props.data.userId) {
        queryDetail()
      } else {
        queryOrg()
      }
    }
  }
)

const disbaledRuleChange = computed(() => {
  return !!props.data.userId
})

const formData = ref({
  username: '',
  nickname: '',
  orgId: '',
  password: '',
  confirmPassword: '',
  email: '',
  mobile: '',
  roleId: '',
})

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
}

const detailLoading = ref(false)
const queryDetail = async () => {
  detailLoading.value = true
  const res: any = await queryUserDetail({
    userId: props.data.userId,
  }).finally(() => {
    detailLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    formData.value = {
      ...formData.value,
      ...res.data,
    }

    orgList.value = [
      {
        value: res.data?.orgId,
        label: res.data?.orgName,
      },
    ]
  }
}

const vailidateMethod = (reg: RegExp, msg: string) => {
  return (rule: any, value: any, callback: any) => {
    if (reg.test(value)) {
      callback()
    } else {
      callback(msg)
    }
  }
}

const validatorComfirPassword = (rule: any, value: any, callback: any) => {
  if (value === formData.value.password) {
    callback()
  } else {
    callback('两次输入的密码不一致')
  }
}

const rules: any = {
  username: [
    { required: true, message: '请输入' },
    {
      validator: vailidateMethod(accountReg, '请输入4-20位英文或数字'),
    },
  ],
  nickname: [{ required: true, message: '请输入' }],
  orgId: [{ required: true, message: '请选择' }],
  password: [
    { required: true, message: '请输入' },
    {
      validator: vailidateMethod(passwordReg, '6-30位字符串'),
    },
  ],
  confirmPassword: [
    { required: true, message: '请输入' },
    {
      validator: validatorComfirPassword,
    },
  ],
  roleId: [{ required: true, message: '请选择' }],
  email: [
    { required: true, message: '请选择' },
    {
      type: 'email',
      message: '请输入正确的邮箱',
    },
  ],
  mobile: [
    { required: true, message: '请输入' },
    {
      validator: vailidateMethod(phoneReg, '请输入正确的手机号码'),
    },
  ],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleAddDevice = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const fn = props.data.userId ? queryUserUpdate : queryUserAdd
      const res: any = await fn({
        ...formData.value,
        userId: props.data.userId,
        // isSaveAlarmContact: isEmpty(formData.value.isSaveAlarmContact) ? 0 : 1,
        password: props.data.userId
          ? undefined
          : encode(formData.value.password),
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: props.data.userId ? '修改用户成功' : '新建用户成功',
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

const orgList: any = ref([])
const queryOrg = async () => {
  const res: any = await queryUserOrg()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const data = res.data
    orgList.value = [
      {
        label: data.name,
        value: data.id,
      },
    ]
  }
}

const roleList: any = ref([])
const queryRole = async () => {
  const res: any = await queryRoleTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    roleList.value = (res.data || []).map((item: any) => {
      // 不能新建超管
      return {
        label: item.name,
        value: item.id,
        disabled: item.isSuperAdmin,
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: props.data.userId ? '编辑用户' : '新建用户',
    class: "config-config-user",
    width: "500px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleAddDevice
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "username",
              label: "帐号名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.username) = $event)),
                  maxlength: "20",
                  placeholder: "用户名为系统登录账号，设置后无法修改",
                  disabled: !!props.data.userId
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            (!props.data.userId)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "password",
                  label: "密码"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
                      maxlength: "50",
                      placeholder: "请输入密码",
                      type: "password",
                      "show-password": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!props.data.userId)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: "confirmPassword",
                  label: "确认密码"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.confirmPassword,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                      maxlength: "50",
                      placeholder: "请输入确认密码",
                      type: "password",
                      "show-password": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "nickname",
              label: "姓名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.nickname,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.nickname) = $event)),
                  maxlength: "50",
                  placeholder: "请输入姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "mobile",
              label: "手机号码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.mobile,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.mobile) = $event)),
                  maxlength: "20",
                  placeholder: "请输入手机号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "email",
              label: "邮箱"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.email) = $event)),
                  maxlength: "50",
                  placeholder: "请输入邮箱"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "orgId",
              label: "所属组织"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.orgId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.orgId) = $event)),
                  class: "ws_select",
                  placeholder: "请选择所属组织",
                  disabled: !!props.data.userId
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "roleId",
              label: "关联角色"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.roleId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.roleId) = $event)),
                  class: "ws_select",
                  placeholder: "请选择关联角色"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value,
                        disabled: item.disabled
                      }, null, 8, ["label", "value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, detailLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})